import { createSlice, current, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@src/redux/store.ts'

type InitialState = {
  location: {
    lat: number
    lng: number
  }
  isRunning: boolean
  isError: boolean
  error: string
  travelMode: boolean
}

type GetLocationSuccessAction = {
  isTravel: boolean
  lat: number
  lng: number
}

const initialState: InitialState = {
  location: { lat: 0, lng: 0 },
  isRunning: false,
  isError: false,
  error: '',
  travelMode: false,
}

const gpsSlice = createSlice({
  name: 'gps',
  initialState,
  reducers: {
    watchPositionStarted: (state) => {
      return { ...state, isRunning: true }
    },
    watchPositionStopped: () => {
      return initialState
    },

    /** geoFence 기능 추가시 사용. **/
    // getLocationSuccess: (state, { payload }) => {
    //   const { data, travelMode } = current(state)
    //   if (travelMode !== payload.isTravel) return
    //
    //   let closest: any = {}
    //   let isInsideOfAnyPlaces = false
    //   const newData = [...data].map((d, i) => {
    //     const cio = checkInsideOne(payload.lat, payload.lon, d.location.lat, d.location.lon, d.radius)
    //     const newObject = { ...d, isInside: cio.isInside, distance: cio.distance }
    //     if (cio.isInside) isInsideOfAnyPlaces = true
    //     closest = i === 0 ? newObject : newObject.distance < closest.distance ? newObject : closest
    //     return newObject
    //   })
    //   return { ...state, isError: false, location: payload, data: newData, closest, isInsideOfAnyPlaces }
    // },

    getLocationSuccess: (state, { payload }: PayloadAction<GetLocationSuccessAction>) => {
      const { travelMode } = current(state)
      if (travelMode !== payload.isTravel) return
      return { ...state, isError: false, location: payload }
    },

    getLocationFail: (state, action: PayloadAction<string>) => {
      return { ...state, isError: true, error: action.payload }
    },

    setTravelMode: (state, { payload }: PayloadAction<boolean>) => {
      return { ...state, travelMode: payload }
    },
  },
})

export const { getLocationSuccess, getLocationFail, watchPositionStarted, watchPositionStopped, setTravelMode } =
  gpsSlice.actions

export const gpsSelector = (state: RootState) => state.gps
export const travelModeSelector = (state: RootState) => state.gps.travelMode

export default gpsSlice.reducer
